module.exports = __webpack_public_path__ + "img/building-mix.19ec516c.svg";